import React, { useEffect } from 'react';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { uniqueId } from 'lodash';
import PropTypes from 'prop-types';

export const BusinessName = ({ inputModel }) => {
  const MAX_LENGTH = 100;

  useEffect(() => {}, []);

  return (
    <React.Fragment>
      <TextInput
        id="w9form-businessName-Field"
        aria-label="type here to enter business name "
        maxLength={MAX_LENGTH}
        isClearable
        name={`name-input-${uniqueId()}`}
        autoComplete="none"
        model={inputModel}
        label="Business name/disregard entity name (optional)"
      />
    </React.Fragment>
  );
};

BusinessName.propTypes = {
  inputModel: PropTypes.string.isRequired,
};

BusinessName.defaultProps = {};
